import { render, staticRenderFns } from "./accpet.vue?vue&type=template&id=94cf4f54&scoped=true"
import script from "./accpet.vue?vue&type=script&lang=js"
export * from "./accpet.vue?vue&type=script&lang=js"
import style0 from "./accpet.vue?vue&type=style&index=0&id=94cf4f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf4f54",
  null
  
)

export default component.exports